import { InjectionToken, inject } from '@angular/core';

import { FeatureFlagService } from '@lib/core/services/feature-flag.service';

/** Remote Config switch for the v2 guarantees tab, so it can be turned off without a deploy. */
export const GUARANTEES_V2_FEATURE_FLAG = 'HM_GUARANTEES_V2_ENABLED';

/** Build-time escape hatch: when the environment sets a boolean it wins over Remote Config. */
export const GUARANTEES_V2_ENABLED_OVERRIDE = new InjectionToken<boolean | null>('GUARANTEES_V2_ENABLED_OVERRIDE');

/**
 * Single source of truth for the v2 guarantees visibility. Must be called in an injection context.
 * Reads the flag once per caller — the flag service re-initialises Firebase on every call.
 */
export function isGuaranteesV2Enabled(): boolean {
  const override = inject(GUARANTEES_V2_ENABLED_OVERRIDE, { optional: true });

  return override ?? inject(FeatureFlagService).isFeatureEnabled(GUARANTEES_V2_FEATURE_FLAG);
}
